import React from 'react';
import { Form, SemanticWIDTHS } from 'semantic-ui-react';

export type SelectDeAlumnosProps = Readonly<{
    alumnos: ReadonlyArray<{
        id: string;
        nombre: string;
    }>;
    idAlumnoSeleccionado: string;
    alSeleccionarAlumno: (idAlumno: string) => void;
    width: SemanticWIDTHS;
}>;

export class SelectDeAlumnos extends React.PureComponent<SelectDeAlumnosProps> {
    public render() {
        const { alumnos, idAlumnoSeleccionado, alSeleccionarAlumno, width } = this.props;

        return (
            <Form.Select
                label='Alumno'
                required
                search
                noResultsMessage='No hay resultados.'
                deburr
                options={alumnos.map(alu => ({
                    key: alu.id,
                    value: alu.id,
                    text: alu.nombre,
                }))}
                value={idAlumnoSeleccionado}
                onChange={(_, { value }) => alSeleccionarAlumno(value as string)}
                width={width}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/componentes/SelectDeAlumnos/index.tsx